import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import Listing from './Listing';
import CarDetails from './CarDetails';
import CarBooking from './CarBooking';
import HowItWorks from './HowItWorks';
import ContactUs from './ContactUs';
import PrivacyPolicy from './PrivacyPolicy';
import TermsConditions from './TermsConditions';
import RefundPolicy from './RefundPolicy';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/listing/:category" element={<Listing />} />
        <Route path="/listing/:category/:link" element={<CarDetails />} />
        <Route path="/booking" element={<CarBooking />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
      </Routes>
    </Router>
  </React.StrictMode>
);
